module.exports = __webpack_public_path__ + "img/x.png.066a9203.webp";